export enum OperationStatus {
  OP_AG_APROV_IF_B3 = 'OP_AG_APROV_IF_B3',
  OP_AG_APROV_DETENTOR = 'OP_AG_APROV_DETENTOR',
  OP_FINALIZADA = 'OP_FINALIZADA',
  OP_REJEITADA = 'OP_REJEITADA',
  OP_AG_APROV_ADQUIRENTE = 'OP_AG_APROV_ADQUIRENTE',
  OP_REJEITADA_POR_IF = 'OP_REJEITADA_POR_IF',
  TIMEOUT = 'TIMEOUT',
}
